module.exports = __webpack_public_path__ + "img/banner1.e8652d07.png";